import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ApplicationStore } from '../../data_layer/stores/ApplicationStore';
import { RouteComponentProps } from 'react-router';
import { when } from 'mobx';
import * as assert from 'assert';
import { ChangeEvent, CSSProperties } from 'react';
import { CONSTANTS } from '../../assets/UIConstants';
import TextInput from '../components/TextInput';
import CustomButton from '../components/Button';
import { Link } from 'react-router-dom';
import { FacebookButton } from '../components/svgs/FacebookButton';

interface Props extends RouteComponentProps<{}> {
    store: ApplicationStore;
}

interface State {
    userName?: string;
    password?: string;
    errorMessage?: string;
}

const SOCIAL_AUTH_BUTTON_WIDTH = 260;
const SOCIAL_AUTH_BUTTON_HEIGHT = 70;

@inject('store')
@observer
export class LogIn extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {};
        assert(undefined != this.props.store.authorizationStore, 'LogIn#constructor, Authorization store returned undefined');
        when(() => {
            return this.props.store.authorizationStore.isAuthenticated;
        },
            () => {
                this.routeToSite();
            });
    }

    public componentWillMount(): void {
        if (this.props.store.authorizationStore.isAuthenticated) {
            this.routeToSite();
        }
    }

    private routeToSite(): void {
        this.props.history.push('');
    }

    private submit(event: ChangeEvent<HTMLFormElement>): void {
        const userName = this.state.userName;
        const password = this.state.password;

        event.preventDefault();

        if (userName && password) {
            this.props.store.authorizationStore.login(userName, password)
                .catch(() => {
                    this.setState({ errorMessage: 'Invalid username or password.' });
                });
        }
    }

    private facebookSignIn(): void {
        this.props.store.authorizationStore.facebookSignIn()
            .catch(() => {
                this.setState({ errorMessage: 'Invalid username or password.' });
            });
    }

    public render() {
        return (
            <div style={pageContainer}>
                <div style={pageHeader}>
                    <div style={pageHeaderTitle}>
                        Body Knowledge
                    </div>
                    <div style={pageHeaderSubTitle}>
                        Welcome to Body Knowledge. Please Sign in using one of the methods below to begin.
                    </div>
                </div>

                <div>
                    {this.state.errorMessage &&
                        <div>{this.state.errorMessage}</div>
                    }
                </div>

                <div style={authOptionsContainer}>

                    <div style={emailAuthArea}>
                        <form
                            onSubmit={(e: ChangeEvent<HTMLFormElement>) => {
                                this.submit(e);
                            }}
                        >
                            <div>
                                <TextInput
                                    label={'Email'}
                                    placeholder={'email'}
                                    id={'user_name'}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        this.setState({ userName: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <TextInput
                                    label={'Password'}
                                    placeholder={'password'}
                                    type={'password'}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        this.setState({ password: e.target.value });
                                    }}
                                />
                            </div>
                            <div style={emailAuthLink}>
                                <div style={submitButtonWrapper}>
                                    <CustomButton
                                        type={'submit'}
                                        isPrimary={true}
                                        style={submitButtonStyle}
                                    >
                                        Sign In
                                    </CustomButton>
                                </div>

                                <Link
                                    to="resetPassword"
                                    style={resetPasswordLink}
                                >
                                    forgot password?
                                </Link>
                            </div>
                        </form>
                    </div>

                    <div style={socialAuthArea}>
                        <div style={socialAuthText}>
                            Or sign in using Facebook
                        </div>
                        <div style={socialAuthButton} onClick={() => this.facebookSignIn()}>
                            <FacebookButton
                                width={SOCIAL_AUTH_BUTTON_WIDTH}
                                height={SOCIAL_AUTH_BUTTON_HEIGHT}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const pageContainer: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 200 + 'px',
    alignItems: 'center',
};

const pageHeader: CSSProperties = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 540 + 'px'
};
const pageHeaderTitle: CSSProperties = {
    fontSize: 28 + 'px',
    textAlign: 'center',
};
const pageHeaderSubTitle: CSSProperties = {
    textAlign: 'center',
    fontSize: 20 + 'px',
    marginTop: 20 + 'px',
    marginBottom: 100 + 'px',
    color: CONSTANTS.COLORS.SUB_TITLE_TEXT_GREY,
};

const authOptionsContainer: CSSProperties = {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
};

const emailAuthArea: CSSProperties = {
    paddingTop: 20 + 'px',
    justifyContent: 'center',
    alignItems: 'center',
};

const emailAuthLink: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'

};
const submitButtonWrapper: CSSProperties = {
    marginTop: 20 + 'px',
};
const submitButtonStyle: CSSProperties = {
    border: 'none',
    boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS,
    textTransform: 'none'
};
const resetPasswordLink: CSSProperties = {
    fontSize: 12 + 'px',
    color: CONSTANTS.COLORS.TABLE_CELL_GREY,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginTop: 20 + 'px',
};

const socialAuthArea: CSSProperties = {
    marginTop: 30 + 'px',
};
const socialAuthText: CSSProperties = {
    fontSize: 14 + 'px',
    color: CONSTANTS.COLORS.TABLE_CELL_GREY,
    marginBottom: 15 + 'px',
    marginTop: 20
};
const socialAuthButton: CSSProperties = {
    cursor: 'pointer',
    height: 69 + 'px',
    borderRadius: 35 + 'px',
    boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS,
    marginBottom: 20 + 'px'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/LogIn.tsx